import { render, staticRenderFns } from "./BeginVerificationDesktopSvg.vue?vue&type=template&id=231aa310&"
import script from "./BeginVerificationDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./BeginVerificationDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports